<template>
  <div class="app-shell">
    <router-view v-slot="{ Component, route }">
      <keep-alive :include="keepAlivePages">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script setup>
const keepAlivePages = ['HomeView'];
</script>

<style scoped>
.app-shell {
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: var(--app-bg);
}
</style>
